import React, { useState, useImperativeHandle, forwardRef } from 'react';
import {
    Form,
    Checkbox,
    Input,
    Message,
    Container,
} from 'semantic-ui-react';

export const ShippingStep = forwardRef(({ initialData }, ref) => {
    const [fullName, setFullName] = useState(initialData?.fullName || '');
    const [email, setEmail] = useState(initialData?.email || '');
    const [phone, setPhone] = useState(initialData?.phone || '');
    const [address, setAddress] = useState(initialData?.address || '');
    const [city, setCity] = useState(initialData?.city || '');
    const [zip, setZip] = useState(initialData?.zip || '');
    const [localErrors, setLocalErrors] = useState({});

    const validateField = (field, value) => {
        let error = '';
        if (field === 'fullName' && !value) error = 'Zadajte meno';
        if (field === 'email' && (!value || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value))) error = 'Neplatný e-mail';
        if (field === 'address' && !value) error = 'Zadajte adresu';
        if (field === 'city' && !value) error = 'Zadajte mesto';
        if (field === 'zip' && (!value || !/^\d+$/.test(value))) error = 'Zadajte správne PSČ';
        if (field === 'phone' && (!/^(0\d[\d ]*|\+\d[\d ]*)$/.test(value))) error = 'Zadajte telefónne číslo v tvare +421... alebo 0...';
        setLocalErrors((prev) => ({ ...prev, [field]: error }));
        return !error;
    };

    useImperativeHandle(ref, () => ({
        validate: () => {
            const e = {};
            if (!fullName) e.fullName = 'Zadajte meno';
            if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) e.email = 'Neplatný e-mail';
            if (!address) e.address = 'Zadajte adresu';
            if (!city) e.city = 'Zadajte mesto';
            if (!zip && !/^\d+$/.test(zip)) e.zip = 'Zadajte PSČ';
            setLocalErrors(e);
            return Object.keys(e).length === 0;
        },
        getValues: () => ({ fullName, email, phone, address, city, zip, method: 'courier' }),
    }));

    return (
        <Form>
            <h4>Adresa doručenia</h4>
            <Form.Field error={!!localErrors.fullName}>
                <label>Celé meno *</label>
                <Input
                    name="name"
                    value={fullName}
                    onChange={(e) => {
                        setFullName(e.target.value);
                        validateField('fullName', e.target.value);
                    }}
                />
                {localErrors.fullName && <Message negative size='tiny' content={localErrors.fullName} />}
            </Form.Field>
            <Form.Field error={!!localErrors.email}>
                <label>E-mail *</label>
                <Input
                    name="email"
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        validateField('email', e.target.value);
                    }}
                />
                {localErrors.email && <Message negative size='tiny' content={localErrors.email} />}
            </Form.Field>
            <Form.Field error={!!localErrors.phone}>
                <label>Telefón</label>
                <Input name="phone" value={phone} onChange={(e) => {
                    setPhone(e.target.value)
                    validateField('phone', e.target.value)
                }} />
                {localErrors.phone && <Message negative size='tiny' content={localErrors.phone} />}
            </Form.Field>
            <Form.Field error={!!localErrors.address}>
                <label>Ulica a číslo *</label>
                <Input
                    name="address"
                    value={address}
                    onChange={(e) => {
                        setAddress(e.target.value);
                        validateField('address', e.target.value);
                    }}
                />
                {localErrors.address && <Message negative size='tiny' content={localErrors.address} />}
            </Form.Field>
            <Form.Group widths='equal'>
                <Form.Field error={!!localErrors.city}>
                    <label>Mesto *</label>
                    <Input
                        name="city"
                        value={city}
                        onChange={(e) => {
                            setCity(e.target.value);
                            validateField('city', e.target.value);
                        }}
                    />
                    {localErrors.city && <Message negative size='tiny' content={localErrors.city} />}
                </Form.Field>
                <Form.Field error={!!localErrors.zip}>
                    <label>PSČ *</label>
                    <Input
                        name="zip"
                        value={zip}
                        onChange={(e) => {
                            setZip(e.target.value);
                            validateField('zip', e.target.value);
                        }}
                    />
                    {localErrors.zip && <Message negative size='tiny' content={localErrors.zip} />}
                </Form.Field>
            </Form.Group>
            <h4>Spôsob doručenia</h4>
            <Form.Group>
                <Container>
                    <Form.Field>
                        <Checkbox radio label='Osobný odber' disabled />
                    </Form.Field>
                    <Form.Field>
                        <Checkbox
                            radio
                            label='Kuriér'
                            name='kurier'
                            checked={true}
                        />
                    </Form.Field>
                </Container>

            </Form.Group>
        </Form>
    );
});